import { render, staticRenderFns } from "./DocumentPdfView.vue?vue&type=template&id=2dd61883&scoped=true"
import script from "./DocumentPdfView.vue?vue&type=script&lang=js"
export * from "./DocumentPdfView.vue?vue&type=script&lang=js"
import style0 from "./DocumentPdfView.vue?vue&type=style&index=0&id=2dd61883&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd61883",
  null
  
)

export default component.exports